import { getCookie } from '../utils/cookiesUtils';

export default function authHeader() {
  try {
    const token = getCookie('platform_token');

    if (token) {
      return { 'Authorization': `Bearer ${token}` };
    }
  }
  catch (error) {
    throw error;
  }
}
//test
